import BaseErrorBoundary from "ErrorHandlers/BaseErrorBoundary";
import React, { Fragment } from "react";

export default class ArticleScreenErrorBoundary extends BaseErrorBoundary {
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex h-screen">
                    <div className="mx-auto my-10">
                        <div className="rounded bg-white p-6 text-gray-800 shadow">
                            {this.state.error.extendedMessage ? (
                                this.state.error.extendedMessage
                            ) : (
                                <Fragment>
                                    <p className="">
                                        {this.state.errorMessage}
                                    </p>
                                    <div className="mt-4 flex items-center justify-center space-x-4">
                                        <a
                                            href="/"
                                            className="focus:outline-none relative inline-flex justify-center rounded-md border border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white  shadow-sm hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 disabled:opacity-50"
                                        >
                                            Reload CEO
                                        </a>
                                        <a
                                            href="https://snworks.zendesk.com/hc/en-us/requests/new"
                                            target="_blank"
                                            rel="noopener, noreferrer"
                                        >
                                            Or,{" "}
                                            <span className="text-green-600 underline">
                                                contact support
                                            </span>
                                            .
                                        </a>
                                    </div>
                                </Fragment>
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
